import React, { useState, useEffect } from 'react';
import { Button, Table, Modal, message } from 'antd';
import Web3 from 'web3';
import { ethers } from 'ethers';
import CreateEditReleaseModal from './CreateEditReleaseModal';
import { NFTABI } from './abis.js';

const web3 = new Web3(window.ethereum);
const CodebaseABI = [{ "inputs": [{ "internalType": "string", "name": "solutionName", "type": "string" }, { "internalType": "string", "name": "symbol", "type": "string" }, { "internalType": "address", "name": "checkedTokenAddress", "type": "address" }, { "internalType": "uint256", "name": "checkedTokenMinBalance", "type": "uint256" }, { "internalType": "bool", "name": "isDAO", "type": "bool" }], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "approved", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "operator", "type": "address" }, { "indexed": false, "internalType": "bool", "name": "approved", "type": "bool" }], "name": "ApprovalForAll", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "ReIssue", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "Revoke", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "indexed": true, "internalType": "bytes32", "name": "previousAdminRole", "type": "bytes32" }, { "indexed": true, "internalType": "bytes32", "name": "newAdminRole", "type": "bytes32" }], "name": "RoleAdminChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "indexed": true, "internalType": "address", "name": "account", "type": "address" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }], "name": "RoleGranted", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "indexed": true, "internalType": "address", "name": "account", "type": "address" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }], "name": "RoleRevoked", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "inputs": [], "name": "ADMIN_ROLE", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "DEFAULT_ADMIN_ROLE", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "IMPLEMENTER_ROLE", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "approve", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "burn", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "getApproved", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "bytes32", "name": "role", "type": "bytes32" }], "name": "getRoleAdmin", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "internalType": "address", "name": "account", "type": "address" }], "name": "grantRole", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "internalType": "address", "name": "account", "type": "address" }], "name": "hasRole", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "operator", "type": "address" }], "name": "isApprovedForAll", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "issueNFT", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "issueTransactions", "outputs": [{ "internalType": "address", "name": "account", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "uint256", "name": "timestamp", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }], "name": "mint", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "ownerOf", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "internalType": "address", "name": "account", "type": "address" }], "name": "renounceRole", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "revoke", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "internalType": "address", "name": "account", "type": "address" }], "name": "revokeRole", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "revokeTransactions", "outputs": [{ "internalType": "address", "name": "account", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "uint256", "name": "timestamp", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }], "name": "safeMint", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "operator", "type": "address" }, { "internalType": "bool", "name": "approved", "type": "bool" }], "name": "setApprovalForAll", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "checkedTokenAddress", "type": "address" }], "name": "setCheckedTokenAddress", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "checkedTokenMinBalance", "type": "uint256" }], "name": "setCheckedTokenMinBalance", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "bytes4", "name": "interfaceId", "type": "bytes4" }], "name": "supportsInterface", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "tokenURI", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "transfer", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "transferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "unlockableContent", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "newUnlockableContent", "type": "string" }], "name": "updateUnlockableContent", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "viewIssueTransactions", "outputs": [{ "components": [{ "internalType": "address", "name": "account", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "uint256", "name": "timestamp", "type": "uint256" }], "internalType": "struct Codebase.Transaction[]", "name": "", "type": "tuple[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "viewRevokeTransactions", "outputs": [{ "components": [{ "internalType": "address", "name": "account", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "uint256", "name": "timestamp", "type": "uint256" }], "internalType": "struct Codebase.Transaction[]", "name": "", "type": "tuple[]" }], "stateMutability": "view", "type": "function" }]

const ReleasesTab = ({ codebase, chainId }) => {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingRelease, setEditingRelease] = useState(null);
  const [account, setAccount] = useState('');
  const [releaseData, setReleaseData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchDao = async () => {
      if (!codebase?.nftContractAddress || !isMounted) return;

      try {
        setLoading(true);
        const accounts = await connectToMetaMask();
        if (isMounted && accounts?.[0]) {
          await fetchReleases(codebase.nftContractAddress, accounts[0]);
        }
      } catch (error) {
        console.error('Error in fetchDao:', error);
        if (isMounted) {
          message.error('Failed to fetch releases data');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchDao();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [codebase?.nftContractAddress]); // Add proper dependency

  const connectToMetaMask = async () => {
    try {
      await window.ethereum.request({ method: 'eth_requestAccounts' });
      const ethereumProvider = new ethers.providers.Web3Provider(window.ethereum);
      const accounts = await ethereumProvider.listAccounts();
      setAccount(accounts[0]);
      return accounts;
    } catch (error) {
      console.error('Error connecting to MetaMask:', error);
      throw error;
    }
  };

  const fetchReleases = async (NFTAddress, account) => {
    if (!NFTAddress || !account) return [];

    const NFTcontractABI = JSON.parse(JSON.stringify(NFTABI));
    const NFTcontract = new web3.eth.Contract(NFTcontractABI, NFTAddress);

    try {
      const releases = await NFTcontract.methods.unlockableContent().call({ from: account });
      if (releases) {
        const releasesObject = JSON.parse(releases);
        setReleases(releasesObject);
        return releasesObject;
      }
      setReleases([]);
      return [];
    } catch (error) {
      console.error('Error fetching releases data:', error);
      setReleases([]);
      return [];
    }
  }

  const handleCreateRelease = () => {
    setEditingRelease(null);
    setModalVisible(true);
  };

  const handleEditRelease = (release) => {
    setEditingRelease(release);
    setModalVisible(true);
  };

  const handleDeleteRelease = (releaseId) => {
    Modal.confirm({
      title: 'Delete Release',
      content: 'Are you sure you want to delete this release?',
      onOk: async () => {
        try {
          // TODO: Replace with actual API call
          // await client.api(`/codebases/${codebase.id}/releases/${releaseId}`, 'delete');
          message.success('Release deleted successfully');
          fetchReleases();
        } catch (error) {
          message.error('Failed to delete release');
        }
      }
    });
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setEditingRelease(null);
  };

  const handleSaveRelease = async (values) => {
    if (typeof window.ethereum !== 'undefined') {
      const networkId = await web3.eth.net.getId();
      window.ethereum.on('accountsChanged', function (accounts) {
        setAccount(accounts[0]);
      });

      if (parseFloat(networkId) === parseFloat(chainId)) {
        if (releaseData?._id) {
          await updateReleaseOnChain(codebase.nftContractAddress, account, releaseData);
        } else {
          await createReleaseOnChain(codebase.nftContractAddress, account, { codeBaseId: codebase._id, ...values });
        }
      } else {
        alert("Wrong network. Please change your wallet network to Chain ID " + chainId);
        window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: web3.utils.toHex(chainId) }]
        });
      }
    }

    setModalVisible(false);
  };

  const generateRandomString = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };

  const createReleaseOnChain = async (NFTAddress, account, release) => {
    const { codeBaseId, name, ...modifiedRelease } = release;
    release._id = generateRandomString(16); // You can adjust the length as needed
    let jsonString = "[" + JSON.stringify(release) + "]";
    console.log('releaseeeeeee', release)
    if (NFTAddress) {
      const NFTcontract = new web3.eth.Contract(CodebaseABI, NFTAddress);
      let releases = '';
      try {
        releases = await NFTcontract.methods.unlockableContent().call({ from: account });
      } catch (e) { }
      releases = releases.trim()
      if (releases) {
        // Chuyển đối tượng thành chuỗi JSON
        const releasesObject = JSON.parse(releases);
        releasesObject.push(release);
        jsonString = JSON.stringify(releasesObject);
      } else {
        const releasesObject = [];
        releasesObject.push(release);
        jsonString = JSON.stringify(releasesObject);
      }
      try {
        // console.log('jsonString:', jsonString);
        try {
          const averageGasPrice = await web3.eth.getGasPrice();
          const aggressiveGasPrice = web3.utils.toBN(averageGasPrice).mul(web3.utils.toBN(120)).div(web3.utils.toBN(100));

          const result = await NFTcontract.methods.updateUnlockableContent(jsonString).send({ from: account, gasPrice: aggressiveGasPrice.toString() });
        } catch (error) {
          console.error('Error calling updateUnlockableContent:', error);
        }
      } catch (error) {
        // Xử lý lỗi nếu cần thiết
      }
    }
  };
  const updateReleaseOnChain = async (NFTAddress, account, release) => {
    const { _id, codeBaseId, name, ...modifiedRelease } = release;
    console.log('release', release)  
    if (!release._id) {


      console.error("Error: _id is required for the release.");

      return;
    }

    let jsonString = "[" + JSON.stringify(release) + "]";

    if (NFTAddress) {
      const NFTcontract = new web3.eth.Contract(CodebaseABI, NFTAddress);

      try {
        // Get existing releases from the contract
        let releases = await NFTcontract.methods.unlockableContent().call({ from: account });
        releases = releases.trim();

        let releasesObject = [];

        if (releases) {
          // Parse existing releases
          releasesObject = JSON.parse(releases);
        }

        // Find the release with the matching _id and update it
        const existingReleaseIndex = releasesObject.findIndex((r) => r._id === _id);

        if (existingReleaseIndex !== -1) {
          releasesObject[existingReleaseIndex] = release;
        } else {
          // If the release with _id doesn't exist, add it to the releasesObject
          releasesObject.push(release);
        }

        jsonString = JSON.stringify(releasesObject);

        try {
          // Get the current gas price in wei
          let gasPrice = await web3.eth.getGasPrice();

          // Increase the gas price by 10% to make it "aggressive"
          let aggressiveGasPrice = Math.floor(gasPrice * 1.1);

          const result = await NFTcontract.methods.updateUnlockableContent(jsonString).send({ from: account, gasPrice: aggressiveGasPrice });
        } catch (error) {
          console.error('Error calling updateUnlockableContent:', error);
        }
      } catch (error) {
        console.error('Error:', error);
        // Handle errors if needed
      }
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <h3 style={{ color: '#03edc3' }}>Releases</h3>
        <button
          style={{
            background: '#232b5b',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 24,
            height: 24,
            fontSize: 18,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '10px',
            marginBottom: '10px'
          }}
          onClick={handleCreateRelease}
        >+</button>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: '#fff', color: '#181c22', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #0006' }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={{ padding: '14px', textAlign: 'left' }}>Name</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Version</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Date</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {releases.map((release) => (
              <tr key={release.id} style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td style={{ padding: '12px' }}>{release?.releaseName}</td>
                <td style={{ padding: '12px' }}>{release?.releaseVersion}</td>
                <td style={{ padding: '12px' }}>{release.releaseDate}</td>
                <td style={{ padding: '12px', textAlign: 'center' }}>
                  <button 
                    onClick={() => handleEditRelease(release)}
                    style={{
                      padding: '4px 8px',
                      margin: '0 4px',
                      background: '#e8f5e9',
                      color: '#2e7d32',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    ✏️
                  </button>
                </td>
              </tr>
            ))}
            {releases.length === 0 && !loading && (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center', color: '#888', padding: 24 }}>No data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <CreateEditReleaseModal
        visible={modalVisible}
        onCancel={handleModalCancel}
        onSubmit={handleSaveRelease}
        editingRelease={editingRelease}
      />
    </div>
  );
};

export default ReleasesTab; 